import { render, staticRenderFns } from "./TotalSoldProductsIndicator.vue?vue&type=template&id=1d0fe598&scoped=true"
import script from "./TotalSoldProductsIndicator.vue?vue&type=script&lang=js"
export * from "./TotalSoldProductsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fe598",
  null
  
)

export default component.exports